'use client';

import { c as _c } from "react/compiler-runtime";
import type { BaseSyntheticEvent, ReactNode } from 'react';
import { type FieldValues, FormProvider, type SubmitErrorHandler, type UseFormReturn } from 'react-hook-form';
import { cn } from '@/lib/styles';
interface Props<T extends FieldValues = FieldValues> {
  readonly form: UseFormReturn<T>;
  readonly onSubmit: (
  // eslint-disable-next-line no-unused-vars
  values: T,
  // eslint-disable-next-line no-unused-vars
  e?: BaseSyntheticEvent<object, unknown, unknown> | undefined) => void;
  readonly onError?: SubmitErrorHandler<T>;
  readonly children: ReactNode;
  readonly className?: string;
  readonly fieldsetClassname?: string;
  readonly id?: string;
  readonly disabled?: boolean;
}
export function AppForm(t0) {
  const $ = _c(18);
  const {
    onSubmit,
    onError: t1,
    children,
    className,
    fieldsetClassname,
    id,
    form,
    disabled
  } = t0;
  const onError = t1 === undefined ? _temp : t1;
  const {
    handleSubmit
  } = form;
  let t2;
  if ($[0] !== handleSubmit || $[1] !== onError || $[2] !== onSubmit) {
    t2 = handleSubmit(onSubmit, onError);
    $[0] = handleSubmit;
    $[1] = onError;
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = fieldsetClassname ? fieldsetClassname : "space-y-4";
  let t4;
  if ($[4] !== t3) {
    t4 = cn(t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== disabled || $[8] !== t4) {
    t5 = <fieldset disabled={disabled} className={t4}>{children}</fieldset>;
    $[6] = children;
    $[7] = disabled;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== className || $[11] !== id || $[12] !== t2 || $[13] !== t5) {
    t6 = <form onSubmit={t2} className={className} id={id} noValidate={true}>{t5}</form>;
    $[10] = className;
    $[11] = id;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== form || $[16] !== t6) {
    t7 = <FormProvider {...form}>{t6}</FormProvider>;
    $[15] = form;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp() {}